import React from 'react'
import { Body, ContentfulRichText } from '@superhi/design'

import Hyperlink from '../../../PostArticle/components/ArticleBody/components/Hyperlink'

const NODE_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['nodeOverrides'] = {
  paragraph: (_, children) => <Body level="1">{children}</Body>,
  hyperlink: (node, children) => <Hyperlink url={node.data.uri}>{children}</Hyperlink>,
}

type Props = {
  children: string
}

const ArticleIntro: React.FC<Props> = ({ children }) => (
  <div>
    <ContentfulRichText nodeOverrides={NODE_OVERRIDES}>{children}</ContentfulRichText>
  </div>
)

export default ArticleIntro
